import React, { Component } from "react";
import { Spinner as BootstrapSpinner } from 'react-bootstrap';

class Spinner extends Component {
  render() {
    return (
      <BootstrapSpinner
        className='codai-spinner'
        as="span"
        animation="grow"
        size="sm"
        role="status"
        aria-hidden="true"
      />
    );
  }
}

export default Spinner;
